export const Messages ={
    StartDate: {
		k: "message.startDate",
		v: "Date"
	},

	Title: {
		k: "message.name",
        v: "Title"
	},

	All: {
		k: "message.type.ALL",
		v: "All"
	},

	Announcement: {
		k: "message.type.Announcement",
		v: "Announcement"
	},

	Info: {
		k: "message.type.Info",
		v: "Info"
	},

	Reminder: {
		k: "message.type.Reminder",
		v: "Reminder"
	},

	Critical: {
		k: "message.type.Critical",
		v: "Critical"
	},

	Alert: {
		k: "message.type.Alert",
		v: "Alert"
	},
	MessageEmpty: {
		k: "messages.empty.title",
		v: "No Messages Available"
	},

	DescriptionEmpty: {
		k: "messages.empty.description",
		v: "Try different filters"
	},

	Type: {
		k: "refine.type",
		v: "Type"
	},
	CreatedBy:{
			k: "message.createdBy",
			v: "Created By"
	},
	Edit: {
			k: "message.edit",
			v: "Edit"
	},

	PostDate: {
		k: "message.startDate",
		v: "Post Date"
	},
	
	MessageEmptyDescription: {
		k: "messages.empty.description",
		v: "Try different search parameters"
}
};


// WEBPACK FOOTER //
// ./src/common/Labels/Messages.ts